var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1724_1414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2638 79.3486H31.0778C30.1508 79.3486 29.3149 79.9072 28.9602 80.7636C28.6055 81.6201 28.8016 82.6061 29.4572 83.2616L46.6431 100.448C47.2986 101.103 48.2846 101.299 49.1411 100.944C49.9976 100.59 50.5561 99.7538 50.5561 98.8269V81.6408C50.5559 80.3749 49.5297 79.3486 48.2638 79.3486Z",
    fill: "#C4CDD5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1724_1414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1803 101.119H48.2638C46.9979 101.119 45.9717 100.093 45.9717 98.8268V86.2251C45.9717 84.9593 44.9454 83.933 43.6795 83.933H31.0778C29.812 83.933 28.7857 82.9067 28.7857 81.6409V25.173C28.7857 23.9071 29.812 22.8809 31.0778 22.8809H80.1803C81.4462 22.8809 82.4725 23.9071 82.4725 25.173V98.8268C82.4725 100.093 81.4462 101.119 80.1803 101.119Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1724_1414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1804 22.8809H55.6292V101.119H80.1805C81.4464 101.119 82.4726 100.093 82.4726 98.8268V25.173C82.4725 23.9071 81.4462 22.8809 80.1804 22.8809Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1925 42.0808L36.2505 39.7725C35.8373 39.5305 35.7005 39.0037 35.945 38.5958C36.1894 38.188 36.7226 38.0536 37.1359 38.2956L41.0779 40.6039C41.4911 40.8459 41.6279 41.3727 41.3835 41.7805C41.139 42.1884 40.6058 42.3228 40.1925 42.0808Z",
    fill: "url(#paint0_linear_1724_1414)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2164 37.5102L41.5541 33.7981C41.275 33.4089 41.3643 32.8721 41.7535 32.5989C42.1428 32.3258 42.6846 32.4198 42.9637 32.809L45.6259 36.5211C45.905 36.9103 45.8158 37.4472 45.4265 37.7203C45.0373 37.9935 44.4955 37.8994 44.2164 37.5102Z",
    fill: "url(#paint1_linear_1724_1414)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1059 47.3883L34.5379 47.3602C34.059 47.3572 33.6771 46.9694 33.6849 46.494C33.6928 46.0185 34.0873 45.6355 34.5662 45.6385L39.1342 45.6666C39.6131 45.6695 39.995 46.0573 39.9872 46.5328C39.9794 47.0082 39.5848 47.3912 39.1059 47.3883Z",
    fill: "url(#paint2_linear_1724_1414)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.8453 78.9867L89.866 78.9659L101.091 90.2563C102.42 91.5852 102.42 93.7397 101.091 95.0687C99.9602 96.1996 98.2315 96.3681 96.9225 95.5743C96.6574 95.4253 96.4081 95.238 96.1825 95.0125L77.8151 76.5399L82.6275 71.7275L89.8453 78.9867Z",
    fill: "#42A2BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.282 38.3682C76.5793 38.3683 85.738 47.5269 85.738 58.8242C85.7379 70.1215 76.5792 79.2801 65.282 79.2803C53.9846 79.2803 44.826 70.1215 44.8259 58.8242C44.8259 47.5268 53.9845 38.3682 65.282 38.3682Z",
    stroke: "#C0E0E9",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7376 58.8249C89.7376 72.3309 78.7881 83.2803 65.2822 83.2803C64.2609 83.2803 63.2562 83.2179 62.2682 83.0952C74.3515 81.61 83.7076 71.3094 83.7076 58.8247C83.7076 46.338 74.3513 36.0375 62.2661 34.5524C63.2542 34.4297 64.2609 34.3672 65.2822 34.3672C78.7881 34.3674 89.7376 45.3169 89.7376 58.8249Z",
    fill: "#80C1D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3214 76.7614C75.3086 76.7614 83.4048 68.6652 83.4048 58.6781C83.4048 48.6909 75.3086 40.5947 65.3214 40.5947C55.3343 40.5947 47.2381 48.6909 47.2381 58.6781C47.2381 68.6652 55.3343 76.7614 65.3214 76.7614Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.942 47.9756L66.5569 63.9611H63.2516L62.8504 47.9756H66.942ZM62.7381 68.8642C62.7381 68.2935 62.9306 67.8161 63.3157 67.4322C63.7115 67.0379 64.2571 66.8407 64.9524 66.8407C65.637 66.8407 66.1772 67.0379 66.573 67.4322C66.9688 67.8161 67.1667 68.2935 67.1667 68.8642C67.1667 69.4142 66.9688 69.8863 66.573 70.2806C66.1772 70.6646 65.637 70.8565 64.9524 70.8565C64.2571 70.8565 63.7115 70.6646 63.3157 70.2806C62.9306 69.8863 62.7381 69.4142 62.7381 68.8642Z",
    fill: "url(#paint3_linear_1724_1414)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1724_1414",
    x: 16.6577,
    y: 65.0803,
    width: 46.0264,
    height: 46.0266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.14025
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06403
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.108708 0 0 0 0 0.237823 0 0 0 0 0.391768 0 0 0 0.0690104 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1724_1414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1724_1414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1724_1414",
    x: 12.6576,
    y: 12.7528,
    width: 77.9429,
    height: 102.494,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06403
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.108708 0 0 0 0 0.237823 0 0 0 0 0.391768 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1724_1414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1724_1414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1724_1414",
    x: 40.6292,
    y: 6.88086,
    width: 52.8435,
    height: 104.238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.108708 0 0 0 0 0.237823 0 0 0 0 0.391768 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1724_1414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1724_1414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1724_1414",
    x1: 35.8698,
    y1: 38.1309,
    x2: 41.6584,
    y2: 38.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1724_1414",
    x1: 41.874,
    y1: 32.1436,
    x2: 47.0388,
    y2: 34.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1724_1414",
    x1: 33.3873,
    y1: 46.1289,
    x2: 38.5521,
    y2: 43.4973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1724_1414",
    x1: 62.7381,
    y1: 47.9756,
    x2: 63.8452,
    y2: 89.3089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.1850004f45e08b1dc1e639668d97c5b3.svg";
export { ForwardRef as ReactComponent };